import React, { useState, useEffect } from 'react';
import { Col, Row, Image, Form, InputGroup } from 'react-bootstrap';
import Card from '../../../components/card/AdminCard';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  GetDocumentModule,
  selectDocumentModule
} from '../../../features/learning/DocumentSlice';
import Back from '../../../assets/images/ic-arrow-back.svg';
import Search from '../../../assets/images/search-line.svg';
import EmptyRow from '../../../components/emptyRow/EmptyRow';
import Feedback from '../../../components/feedbackNote/Feedback';

const title: String = '';

const DocumentModulesEditDetails = () => {
  const DocumentModule = useAppSelector(selectDocumentModule);
  const dispatch = useAppDispatch();
  // console.log("LearingModule", DocumentModule);
  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  useEffect(() => {
    var data = {
      keyword: '',
      offset: 0,
      companyId: userDetailsJson.companyId
    };
    async function fetchLearningModuleData() {
      let sample = await dispatch(GetDocumentModule(data));
    }

    fetchLearningModuleData();
  }, []);

  const [searchData, setsearchData] = useState('');
  const fetchLearningModuleData = () => {
    var data = {
      keyword: '',
      offset: 0,
      companyId: userDetailsJson.companyId
    };
    dispatch(GetDocumentModule(data));
  };
  const searchItems = async (searchValue: any) => {
    await setsearchData(searchValue);
    var data = {
      keyword: searchData,
      offset: 0,
      companyId: userDetailsJson.companyId
    };

    await dispatch(GetDocumentModule(data));
  };

  const rowLearnArrayData = DocumentModule?.slice(0, 4);
  const Learnlist: any = rowLearnArrayData;

  return (
    <>
      <Feedback pageName='Learning And Awarness' />
      <Row>
        <Col sm={12}>
          <a href='/documentmodulesDetails'>
            <span style={styles.backstyle}>
              <Image src={Back} />
              Back{' '}
            </span>
          </a>
        </Col>
      </Row>
      <EmptyRow />

      <Row>
        <Col sm={8}>
          <h4>Document</h4>
        </Col>

        <Col sm={4}>
          <InputGroup
            className='border bg-white'
            style={{ border: 'solid 1px #e4e4e4' }}
          >
            <Image
              style={styles.image1}
              className='d-inline border-0 my-auto mx-2'
              src={Search}
              fluid
            />
            <Form.Control
              onChange={(e) => searchItems(e.target.value)}
              name={searchData}
              className='border-0 shadow-none ps-0'
              style={styles.text1}
              type='text'
              placeholder='Search'
            />
          </InputGroup>
        </Col>
      </Row>

      <EmptyRow />

      <div style={{ marginBottom: '20px' }}>
        <Card
          type={4}
          title={title}
          data={DocumentModule}
          moduleid={4}
          fetchLearningModuleData={fetchLearningModuleData}
          modal={
            <>
              {/* <LearningModulesModal title="Learning Modules" records={LearingModule}/> */}
              {/* <LearningModulesEdit data={LearingModule}/> */}
            </>
          }
        />

        {/* <Card
          type={2}
          title={title2}
          data={consellList}
          modal={
            <>
              <LearningModulesModal  title="Ethics Counsellor Programs" records={CounsellorModule} />
              <LearningModulesEdit title="Edit Ethics Counsellors Program" data={CounsellorModule}/>
            </>
          }
        /> */}
      </div>
    </>
  );
};

const styles: any = {
  editstyle: {
    color: '#e31837',
    fontFamily: 'Saira',
    fontWeight: 600,
    fontSize: '12px',
    float: 'right',
    marginTop: '10px'
  },

  backstyle: {
    color: '#e31837',
    fontFamily: 'Saira',
    fontWeight: 600,
    fontSize: '12px',
    marginTop: '10px'
  }
};

export default DocumentModulesEditDetails;
